import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import type { Permission } from "src/constants/permissions";

interface PermissionsResponse {
	permissions: string[];
}

const fetchPermissions = async (): Promise<string[]> => {
	const { data } = await cmsClient.get<PermissionsResponse>("/permissions/");
	return data.permissions;
};

const usePermissions = () => {
	const query = useQuery(["user-permissions"], fetchPermissions, {
		staleTime: 5 * 60 * 1000
	});

	const hasPermission = (permission: Permission | string): boolean => {
		return query.data?.includes(permission) ?? false;
	};

	const hasAnyPermission = (permissions: (Permission | string)[]): boolean => {
		return permissions.some((p) => query.data?.includes(p) ?? false);
	};

	return {
		permissions: query.data ?? [],
		hasPermission,
		hasAnyPermission,
		isLoading: query.isLoading,
		isError: query.isError
	};
};

export default usePermissions;
